import { useContext } from 'react'
import { AnalyticsContext, AnalyticsContextValue } from './AnalyticsProvider'

export default (): AnalyticsContextValue => useContext(AnalyticsContext)
